const globalStyle = getComputedStyle(document.documentElement);

export const getStripeElementsConfig = () => ({
  fonts: [{ cssSrc: '/assets/fonts/style.css' }],
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: globalStyle.getPropertyValue('--primary'),
      colorBackground: globalStyle.getPropertyValue('--white'),
      colorDanger: '#dc2839',
      colorText: '#2c2c2c',
      colorTextPlaceholder: '#777777',
      fontFamily: globalStyle.getPropertyValue('--font-family-sans-serif'),
      spacingUnit: '3px',
      borderRadius: '5px',
    },
    rules: {
      '.Label': {
        fontSize: '0.7rem',
        color: 'var(--colorPrimary)',
        boxShadow: 'none',
      },
      '.Label--empty': {
        color: 'var(--colorPrimary)',
      },
      '.Label--invalid': {
        color: 'var(--colorDanger)',
      },
      '.Input': {
        fontSize: '0.85rem',
        border: '1px solid #d9d9d9',
      },
      '.Input:focus': {
        boxShadow: '0 3px 10px 0 #00000026',
      },
      '.Input--invalid': {
        boxShadow: '0 0 0 0.2rem #dc283940',
      },
      '.Tab': {
        fontWeight: '400',
      },
      '.Tab--selected': {
        boxShadow: '0 3px 10px 0 #00000026',
      },
      '.Tab--selected:focus': {
        boxShadow: '0 3px 10px 0 #00000026',
      },
      '.TermsText': {
        fontSize: '0.7rem',
      },
      '.Error': {
        fontSize: '0.7rem',
        marginTop: '0.35rem',
      },
    },
  },
});
